import React from "react";
import EstatePage from "@/components/sites/EstatePage";
import { useBrand } from "@/lib/brand";

/**
 * Terms, privacy and cookies, in the Estate theme.
 *
 * The agency's own documents, from `brand.legal.<kind>`. Nothing is
 * generated: a privacy notice Foundation wrote and put an agency's name on
 * is a legal document they have not read, published as though they had.
 * With no document there is no page rather than a placeholder one.
 */
const TITLES = { terms: "Terms of use", privacy: "Privacy notice", cookies: "Cookies" };

export default function EstateLegal({ kind = "terms", preview = true }) {
  const brand = useBrand();
  const biz = brand.business || {};
  const doc = (brand.legal || {})[kind];

  if (!doc) {
    return (
      <EstatePage preview={preview} cta={false}
                  heading={TITLES[kind] || "Legal"} crumbs={[{ label: TITLES[kind] || "Legal" }]}>
        <p className="lede">
          This document is not published here yet.
          {biz.email ? <> Ask us for a copy at <a className="link" href={`mailto:${biz.email}`}>{biz.email}</a>.</> : null}
        </p>
      </EstatePage>
    );
  }

  return (
    <EstatePage
      preview={preview}
      cta={false}
      title={`${doc.title || TITLES[kind]}, ${biz.name || ""}`.trim().replace(/,$/, "")}
      description={doc.sections?.[0]?.paragraphs?.[0] || undefined}
      eyebrow={biz.name || ""}
      heading={doc.title || TITLES[kind]}
      lede=""
      crumbs={[{ label: doc.title || TITLES[kind] }]}
    >
      {doc.updated && (
        <p className="note" style={{ marginBottom: 24 }}>Last updated {doc.updated}</p>
      )}
      <div className="prose">
        {(doc.sections || []).map((section, n) => (
          <section key={section.heading || n}>
            {section.heading && <h2>{section.heading}</h2>}
            {(section.paragraphs || []).map((para, i) => <p key={i}>{para}</p>)}
          </section>
        ))}
      </div>
    </EstatePage>
  );
}
